import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import FounderCard from '@/components/Cards/FounderCard';
import s from './index.module.scss';

export const BrandFounders = ({ founders }) => {
  const { t } = useTranslation('brands');
  if (!founders || !founders?.length) return null;

  if (founders.length === 1) {
    return (
      <div className={s.wrapper}>
        <h2 className={s.title} style={{ marginBottom: '20px' }}>
          {t('brand_detail.founders')}
        </h2>
        <FounderCard founder={founders[0]} />
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      <h2 className={s.title}>{t('brand_detail.founders')}</h2>
      <div className={s.container}>
        <Swiper spaceBetween={12} slidesPerView="auto">
          {founders.map(founder => (
            <SwiperSlide key={founder.id} style={{ width: '285px' }}>
              <FounderCard founder={founder} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
